export const PaymentTypeChoices = [
    { label: 'Nessuna', value: '' },
    { label: 'Istituzionale', value: 'istituzionale' },
    { label: 'Commerciale', value: 'commercial' },
]
